import * as React from 'react';
import { Translate } from '../../../../../../shared/LanguageService';
import history from '../../../../../../shared/history';
import BaseTab from './BaseTab';

type CustomerOrdersTabProps = {
    label: string;
};

const CustomerOrdersRoute = '/orders';
let routes = [CustomerOrdersRoute];

function CustomerOrdersTab({ label, ...props }: CustomerOrdersTabProps) {
    function handleClick() {
        history.push(CustomerOrdersRoute);
    }

    return <BaseTab {...props} onClick={handleClick} label={label} route={CustomerOrdersRoute} />;
}

function TranslatedCustomerOrdersTab(props) {
    const label = Translate('header/nav/orders-list');
    return <CustomerOrdersTab {...props} label={label} />;
}

TranslatedCustomerOrdersTab.routes = routes;

export default TranslatedCustomerOrdersTab;
